import React, { useEffect, useState } from "react";
import CategoryPage from "./CategoryPage";
import CategoryPageMobile from "./CategoryPageMobile";

export default function ResponsiveCategoryPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <CategoryPageMobile /> : <CategoryPage />;
}
